<template>
  <page class="page-wrap">
    <live-header @handleSearch="searchList" placeholder="请输入精彩直播">
    </live-header>
    <swiper ref="swiper"></swiper>
    <template slot="content">
      <live-list1></live-list1>
    </template>
  </page>
</template>
<script>
import Page from '@/views/layout/index'
import Swiper from '@/components/swiper'
import { getSaasInfo } from '@/api/wbs'
import liveList1 from './live_list1'
import LiveHeader from '@/components/header'
export default {
  components: {
    Page,
    Swiper,
    liveList1,
    LiveHeader
  },
  data () {
    return {
    }
  },
  mounted () {
    this.findSwiper()
  },
  methods: {
    findSwiper () {
      const obj = {
        url: '/http/saas/banner/queryBanner.json',
        data: {
          platform: 3,
          position: 10
        }
      }
      getSaasInfo(obj).then(res => {
        if (res.success) {
          this.$refs.swiper.swiperList = res.data && res.data.pictureUrls ? res.data.pictureUrls : []
          this.$refs.swiper.linkurls = res.data && res.data.linkurls ? res.data.linkurls : []
        } else {
          this.$showError(res.msg)
        }
      })
    },
    searchList (val) {
      this.$router.push({
        name: 'live',
        params: {
          keyword: val || ''
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.page-wrap ::v-deep .common-content{
  width:1200px;
  margin:0 auto;
}
@media screen and (max-width: 1200px){
  .page-wrap ::v-deep .common-content{
    width:100%
  }
}
</style>
